'use client';

import Link from 'next/link';

export default function Footer() {
  return (
    <footer className="bg-brand-plum text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="font-headline text-2xl mb-4">The Lone Star Local</h3>
            <p className="font-body text-white/80">
              Boutique. Selective. Grounded.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-body font-semibold text-lg mb-4">Navigation</h4>
            <nav className="space-y-2">
              <Link href="/homepage" className="block font-body text-white/80 hover:text-brand-teal transition-smooth">
                Home
              </Link>
              <Link href="/portfolio" className="block font-body text-white/80 hover:text-brand-teal transition-smooth">
                Work
              </Link>
              <Link href="/services" className="block font-body text-white/80 hover:text-brand-teal transition-smooth">
                Services
              </Link>
              <Link href="/about" className="block font-body text-white/80 hover:text-brand-teal transition-smooth">
                About
              </Link>
              <Link href="/contact" className="block font-body text-white/80 hover:text-brand-teal transition-smooth">
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-body font-semibold text-lg mb-4">Get in Touch</h4>
            <p className="font-body text-white/80 mb-2">
              Based in Dallas, Texas
            </p>
            <p className="font-body text-white/80">
              hello@lonestarlocal.com
            </p>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 text-center">
          <p className="font-body text-white/70">
            © {new Date()?.getFullYear()} The Lone Star Local. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}